import classNames from "classnames";
import {
  WalletDropdownElement,
  SelectionDropdown,
  ArrowDown,
} from "components/modals/shared/selection-dropdown";
import { useCustomWallet } from "components/providers";
import { BasicProps } from "components/types/BasicProps";
import { ChangeEvent, FC, useMemo, useState } from "react";

type Props = BasicProps & {
  label?: string;
  placeholder?: string;
  defaultValue?: string;
  onChange: (address: string) => void;
};

export const AddressInput: FC<Props> = (props) => {
  const {
    className,
    label = "Send to",
    placeholder = "Enter public address (0x) or ENS name",
    onChange,
    defaultValue,
  } = props;
  const { address } = useCustomWallet();
  const [isSelectWalletOpen, setSelectWalletOpen] = useState<boolean>(false);
  const [optionSelected, setOptionSelected] =
    useState<string>("external-wallet");
  const toggleSelectWallet = () => setSelectWalletOpen(!isSelectWalletOpen);

  const options = useMemo(
    () => [
      {
        selected: optionSelected === "connected-wallet",
        Content: (
          <WalletDropdownElement
            label="Connected Wallet"
            imageSrc="/assets/images/wallet-logo.png"
          />
        ),
        value: "connected-wallet",
        handleClick: () => {
          setOptionSelected("connected-wallet");
          setSelectWalletOpen(false);
          onChange(address || "");
        },
      },
      {
        selected: optionSelected === "external-wallet",
        Content: (
          <WalletDropdownElement
            label="External Wallet"
            imageSrc="/assets/images/wallet-logo.png"
          />
        ),
        value: "external-wallet",
        handleClick: () => {
          setOptionSelected("external-wallet");
          setSelectWalletOpen(false);
          onChange("");
        },
      },
    ],
    [optionSelected]
  );

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    onChange(event.target.value);
  };

  return (
    <div
      className={classNames(
        "relative w-full border border-white rounded-[15px]",
        className
      )}
    >
      {isSelectWalletOpen ? (
        <SelectionDropdown
          className="bg-secondary w-[100.5%] !border !rounded-[15px] top-[-1px] left-[-1px]"
          heightClassName="h-[87px]"
          options={options}
          title="Select a wallet to withdraw to"
          zIndexClassName="z-[99999]"
          openByDefault={true}
        />
      ) : (
        <label
          className={classNames(
            "w-full absolute top-0 left-0  pt-[15px] pr-5 pb-5 pl-[25px]"
          )}
          htmlFor="address"
        >
          <div className="w-full flex justify-between items-center gap-4">
            <div className="w-full flex flex-col justify-between gap-2.5">
              <span className="text-xs">{label}</span>
              <input
                className="placeholder-[#A5A8B6] bg-transparent !outline-none"
                placeholder={placeholder}
                type="text"
                defaultValue={defaultValue}
                onChange={handleChange}
              />
            </div>
            <div onClick={toggleSelectWallet}>
              <ArrowDown widthAndHeight={20} />
            </div>
          </div>
        </label>
      )}
    </div>
  );
};
